<template>
	<div class="zm-loader">
		<i class="fas fa-spin fa-spinner" :style="style"></i>
	</div>
</template>

<script>

export default {
	name: 'Loader',
	props: {
		size: {
			type: Number,
			default: 24,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		style: function() {
			return {
				'font-size': this.size + 'px',
			};
		},
	},
	methods: {
	},
}
</script>

<style lang="scss">
.zm-loader {
	width: 100%;
	text-align: center;
}

</style>
